
// @ts-ignore
export const getMinQty = (prices) => Math.min(...Object["values"](prices).map((p) => p.min));
